import React, { FunctionComponent } from 'react'
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export enum ThumbDirection {
  UP = 'up',
  DOWN = 'down',
}

export const ThumbIcon: FunctionComponent<ThumbIconProps> = ({
  size = 16,
  fillColor,
  direction = ThumbDirection.UP,
  isFilled = false,
}) => {
  const { colors } = useTheme()
  const rotation = direction === ThumbDirection.DOWN ? 180 : 0

  return (
    <Svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      testID={tID('ThumbIcon')}
      style={{ transform: [{ rotate: `${rotation}deg` }] }}
    >
      {isFilled ? (
        <Path
          d='M4 14.667L3.33789 14.6602C1.99001 14.6298 1.94241 14.4951 1.72363 14.2764C1.47369 14.0263 1.33301 13.6866 1.33301 13.333V8.66699C1.33301 8.31337 1.47358 7.97368 1.72363 7.72363C1.97368 7.47358 2.31337 7.33301 2.66699 7.33301H4V14.667ZM7.33398 1.33301C7.86424 1.33314 8.37309 1.54399 8.74805 1.91895C9.123 2.2939 9.33386 2.80275 9.33398 3.33301V6H13.1064C13.2997 5.99781 13.4916 6.03804 13.668 6.11719C13.8442 6.19633 14.0011 6.31317 14.1279 6.45898C14.2547 6.60479 14.3485 6.77638 14.4023 6.96191C14.4561 7.14736 14.4694 7.34229 14.4404 7.5332L13.5205 13.5332C13.4723 13.8511 13.3104 14.1413 13.0654 14.3496C12.8204 14.5578 12.5081 14.6706 12.1865 14.667H5V6.58301L7.33398 1.33301Z'
          fill={fillColor || colors.iconActive}
        />
      ) : (
        <G clip-path='url(#clip0_342_18070)'>
          <Path
            d='M4.66683 7.3335L7.3335 1.3335C7.86393 1.3335 8.37264 1.54421 8.74771 1.91928C9.12278 2.29436 9.3335 2.80306 9.3335 3.3335V6.00016H13.1068C13.3001 5.99797 13.4915 6.03783 13.6679 6.11697C13.8442 6.19612 14.0012 6.31265 14.1281 6.45851C14.2549 6.60436 14.3485 6.77604 14.4024 6.96166C14.4563 7.14728 14.4692 7.3424 14.4402 7.5335L13.5202 13.5335C13.4719 13.8514 13.3105 14.1412 13.0654 14.3495C12.8204 14.5578 12.5084 14.6705 12.1868 14.6668H4.66683M4.66683 7.3335V14.6668M4.66683 7.3335H2.66683C2.31321 7.3335 1.97407 7.47397 1.72402 7.72402C1.47397 7.97407 1.3335 8.31321 1.3335 8.66683V13.3335C1.3335 13.6871 1.47397 14.0263 1.72402 14.2763C1.97407 14.5264 2.31321 14.6668 2.66683 14.6668H4.66683'
            stroke={fillColor || colors.iconActive}
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </G>
      )}
      <Defs>
        <ClipPath id='clip0_342_18070'>
          <Rect width='16' height='16' fill='white' />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export interface ThumbIconProps {
  size?: number
  fillColor?: string
  direction?: ThumbDirection
  isFilled?: boolean
}

// Legacy export for backward compatibility
export const ThumbsUpIcon = ThumbIcon
export type ThumbsUpIconProps = ThumbIconProps
